// extracted by mini-css-extract-plugin
export default {"bannerslider":"banner_bannerslider__BKI+q","bannerslide":"banner_bannerslide__8-sbQ","bannerimage":"banner_bannerimage__TDFYu"};